import type { ComponentTwinsGroupResponseDto } from '@evimo/types';
import type { AssetDetailComponent } from '~/app/services/asset/asset.service';

export type TwinsGroupFormValues = {
  groupName: string;
  componentTwinsIds: string[];
};

export type ComponentOption = {
  value: string;
  label: string;
};

export type EditingTwinsGroup = ComponentTwinsGroupResponseDto | null;

export function toComponentOptions(
  components: AssetDetailComponent[],
): ComponentOption[] {
  return components.map((component) => ({
    value: component.id,
    label: component.serialNumber
      ? `${component.name} (${component.serialNumber})`
      : component.name,
  }));
}

export function memberLabels(
  group: ComponentTwinsGroupResponseDto,
  componentsById: Map<string, AssetDetailComponent>,
): string {
  return group.componentTwinsIds
    .map((id) => componentsById.get(id)?.name ?? id)
    .join(', ');
}
